"use client";

import { notNull } from "../../../helpers/notNull";
import { isLifecyclePhase } from "../../../helpers/typeguards";
import { SustainabilityRail } from "../sustainability-rail/sustainability-rail";
import { LifecycleCta } from "./lifecycle-cta/lifecycle-cta";
import { LifecyclePhase } from "./lifecycle-phase/lifecycle-phase";
import { LifecycleNewStage } from "./lifecycle-stage/lifecycle-stage";
import { NewLifecycleStage, NewlifecyclePhaseType } from "./lifecycle.types";
import classNames from "classnames/bind";
import { useState } from "react";
import styles from "./lifecycle.module.css";

const cx = classNames.bind(styles);

export const NewLifecycle = ({
  phasesCollection,
  stage,
}: {
  stage: NewLifecycleStage | null;
  phasesCollection: Array<NewlifecyclePhaseType> | null;
}) => {
  const lifecyclePhases =
    phasesCollection?.filter(notNull).filter(isLifecyclePhase) || [];

  const [activeLifecyclePhase, setActiveLifecyclePhase] = useState<
    string | undefined
  >();

  return (
    <div>
      {stage && (
        <LifecycleNewStage
          kicker={stage.kicker}
          title={stage.title}
          text={stage.text || stage.textLong}
          videoText={stage.videoText}
          videoPlayerId={stage.videoPlayerId}
          hasTeaser={Boolean(stage.rail)}
        />
      )}
      {stage?.rail && (
        <SustainabilityRail
          title={stage?.rail.title ?? null}
          text={stage.rail.text ?? null}
          cardsCollection={
            stage.rail.cardsCollection?.map((item) => ({
              title: item?.title ?? null,
              description: item?.description ?? null,
              link: item?.link ?? null,
              linkText: item?.linkText ?? null,
              media: {
                contentType: item?.media?.contentType ?? null,
                url: item?.media?.url ?? null,
                description: item?.media?.description ?? null,
              },
            })) ?? null
          }
        />
      )}
      <nav className={cx("navigation")}>
        <div className={cx("navigation-wrapper")}>
          <div className={cx("navigation-inner-wrapper")}>
            {lifecyclePhases.map((phase, index) => (
              <a
                key={index}
                className={cx("navigation-link", {
                  active: activeLifecyclePhase === phase.id,
                })}
                href={`#${phase.title?.toLowerCase()}`}
                data-ref={phase.title?.toLowerCase()}
              >
                {phase.title}
              </a>
            ))}
          </div>
        </div>
      </nav>
      {phasesCollection?.filter(notNull).map((item, index) => {
        switch (item.__typename) {
          case "LifecyclePhase":
            return (
              <LifecyclePhase
                key={index}
                phase={item}
                characterVideoUrl={item.videoUrl ?? null}
                index={index}
                onEnterViewport={setActiveLifecyclePhase}
              />
            );
          case "LifecycleCta":
            return (
              <LifecycleCta
                key={index}
                cta={item}
                characterVideoUrl={item.videoUrl}
                index={index}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
};
